import FlexPane from './_flex-pane.js'
import ShareBet from './_share-bet.js'
import ChangedValueIndicator from './_changed-value-indicator.js'
import Text from './_text.js'
import Cashout from './_cashout.js'
import TotalPayoutInfo from './_total-payout-info.js'
import StakeInfo from './_stake-info.js'
import PayoutInfo from './_payout-info.js'
import Button from './_button.js'
import MatchAccaSelectionItem from './_match-acca-selection-item.js'
import Image from './_image.js'
import BetStatusIcon from './_bet-status-icon.js'
import Hideable from './_hideable.js'
import DateTime from './_date-time.js'
import LegInfoRow from './_leg-info-row.js'
import EarlyPayoutIndicator from './_early-payout-indicator.js'
import FormattedLabelWithTotalOdds from './_formatted-label-with-total-odds.js'
import OddsBoostNotification from './_odds-boost-notification.js'

export default {
  name: 'YourBetView',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          borderRadius: '8px',
          flexDirection: 'column',
          flexBasis: '0px',
          overflow: 'hidden',
        },
      },
    },
    betShareAndCashoutContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'center',
        },
      },
    },
    cashoutNotificationsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px',
        },
      },
    },
    shareBetContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          padding: '8px',
        },
      },
    },
    shareBet: {
      configSet: ShareBet,
      configValues: {},
    },
    betHeaderContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '8px 7px',
        },
      },
    },
    startingPriceIndicator: {
      configSet: ChangedValueIndicator,
      configValues: {},
    },
    betHeaderOddsBoostBetContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '8px 7px',
        },
      },
    },
    betHeaderText: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
        style: {
          textTransform: 'uppercase',
        },
      },
    },
    dateText: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    betFundsInfoContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '8px',
        },
      },
    },
    betFundsInnerContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    cashout: {
      configSet: Cashout,
      configValues: {
        container: {
          style: {
            padding: '8px',
          },
        },
      },
    },
    totalPayoutInfo: {
      configSet: TotalPayoutInfo,
      configValues: {
        payout: {
          betInfo: {
            icon: {
              src: 'acca_boost',
              style: {
                minWidth: '18px',
                minHeight: '16px',
                padding: '0 4px 0 0',
              },
            },
          },
        },
        payoutAfterTax: {
          betInfo: {
            icon: {
              src: 'acca_boost',
              style: {
                minWidth: '18px',
                minHeight: '16px',
                padding: '0 4px 0 0',
              },
            },
          },
        },
      },
    },
    totalStakeInfo: {
      configSet: StakeInfo,
      configValues: {},
    },
    oddsBoostInfo: {
      configSet: PayoutInfo,
      configValues: {},
    },
    placeDateContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          flexBasis: 'initial',
        },
      },
    },
    selections: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    selectionsButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            padding: '2px 16px 5px',
          },
        },
      },
    },
    matchAccaSelectionButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexDirection: 'column',
          },
        },
      },
    },
    matchAccaSelectionContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '2px 16px 5px',
        },
      },
    },
    matchAccaSelectionItem: {
      configSet: MatchAccaSelectionItem,
      configValues: {},
    },
    labels: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          padding: '0 4px 0 0',
        },
      },
    },
    selectionName: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 0 8px',
        },
      },
    },
    marketNameContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: 4,
        style: {
          alignItems: 'flex-start',
        },
      },
    },
    suspendedMarket: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    marketName: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
        style: {
          overflowWrap: 'break-word',
        },
      },
    },
    eventName: {
      configSet: Text,
      configValues: {},
    },
    oddsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          alignItems: 'flex-start',
          flexGrow: '0',
        },
      },
    },
    odds: {
      configSet: Text,
      configValues: {
        container: undefined,
      },
    },
    priceTextContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          alignItems: 'flex-end',
          padding: '0 0 0 8px',
        },
      },
    },
    matchAccaBetInfoContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          width: '100%',
          flexDirection: 'column',
          padding: '0 0 0 20px',
        },
      },
    },
    betInfoContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          width: '100%',
          flexDirection: 'column',
          padding: '0 0 0 20px',
        },
      },
    },
    statusIconContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'center',
        },
      },
    },
    errorContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0 0 4px 0',
        },
      },
    },
    errorIcon: {
      configSet: Image,
      configValues: {
        src: 'leg-status-lost-icon',
        style: {
          minWidth: '14px',
          minHeight: '10px',
          padding: '0 4px 0 0',
        },
      },
    },
    freeBetIcon: {
      configSet: Image,
      configValues: {
        src: 'freebet-filled',
        style: {
          minWidth: '16px',
          minHeight: '16px',
          padding: '0 4px 0 0',
        },
      },
    },
    bonusIcon: {
      configSet: Image,
      configValues: {
        src: 'prewager',
        style: {
          minWidth: '16px',
          minHeight: '16px',
          padding: '0 4px 0 0',
        },
      },
    },
    bestOddsIcon: {
      configSet: Image,
      configValues: {
        src: 'racing-bestodds',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    matchAccaHeaderText: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '0 0 4px 4px',
        },
      },
    },
    matchAccaSelectionIcon: {
      configSet: Image,
      configValues: {
        src: 'match-acca-slip-separator',
        style: {
          minWidth: '14px',
          minHeight: '10px',
          padding: '0 4px 0 0',
        },
      },
    },
    matchAccaEventName: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 4px 0',
        },
      },
    },
    matchAccaEventNameIndicator: {
      configSet: Text,
      configValues: {},
    },
    legStatusIcon: {
      configSet: BetStatusIcon,
      configValues: {
        open: {
          style: {
            width: '13px',
            minHeight: '17px',
          },
        },
        lost: {
          style: {
            width: '13px',
            minHeight: '17px',
          },
        },
        void: {
          style: {
            width: '13px',
            minHeight: '17px',
          },
        },
        won: {
          style: {
            width: '13px',
            minHeight: '17px',
          },
        },
        cashedOut: {
          style: {
            width: '13px',
            minHeight: '17px',
          },
        },
      },
    },
    errorLabel: {
      configSet: Text,
      configValues: {},
    },
    placementDate: {
      hide: false,
      $mixin: [
        {
          configSet: Hideable,
        },
      ],
    },
    eventNameTimeFormat: {
      configSet: DateTime,
      configValues: {
        format: 'SHORT_TIME',
      },
    },
    betPlacementDateTimeFormat: {
      configSet: DateTime,
      configValues: {
        format: 'NUMERIC_DATE_TIME',
      },
    },
    legInfoRow: {
      configSet: LegInfoRow,
      configValues: {},
    },
    priceBoostIndicator: {
      configSet: ChangedValueIndicator,
      configValues: {
        container: {
          style: {
            alignItems: 'center',
          },
        },
        indicationIcon: {
          src: 'double-arrow-right',
          style: {
            minWidth: '12px',
            minHeight: '12px',
          },
        },
      },
    },
    notificationContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexWrap: 'wrap',
        },
      },
    },
    earlyPayoutIndicator: {
      configSet: EarlyPayoutIndicator,
      configValues: {
        popover: {
          popup: {
            container: {
              style: {
                top: '32px',
                _desktop_left: 'auto',
              },
            },
            _desktop_arrowheadOffset: '50%',
          },
        },
      },
    },
    totalOdds: {
      configSet: FormattedLabelWithTotalOdds,
      configValues: {},
    },
    oddsBoostNotification: {
      configSet: OddsBoostNotification,
      configValues: {},
    },
    matchAccaOddsBoostNotification: {
      configSet: OddsBoostNotification,
      configValues: {
        container: {
          style: {
            padding: '8px 0 4px 0',
          },
        },
      },
    },
    betHeaderInnerContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'space-between',
        },
      },
    },
    betStatusContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexGrow: 0,
          justifyContent: 'flex-end',
          alignItems: 'flex-start',
        },
      },
    },
    settledStatusIcon: {
      configSet: BetStatusIcon,
      configValues: {
        lost: {
          style: {
            width: '13px',
            minHeight: '17px',
          },
        },
        void: {
          style: {
            width: '13px',
            minHeight: '17px',
          },
        },
        won: {
          style: {
            width: '13px',
            minHeight: '17px',
          },
        },
        cashedOut: {
          style: {
            width: '13px',
            minHeight: '17px',
          },
        },
      },
    },
    betStatusText: {
      configSet: Text,
      configValues: {
        style: {
          textTransform: 'uppercase',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
